import { render, staticRenderFns } from "./ModificarOrdenVenta.vue?vue&type=template&id=3832c44f&scoped=true&"
import script from "./ModificarOrdenVenta.vue?vue&type=script&lang=js&"
export * from "./ModificarOrdenVenta.vue?vue&type=script&lang=js&"
import style0 from "./ModificarOrdenVenta.vue?vue&type=style&index=0&id=3832c44f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3832c44f",
  null
  
)

export default component.exports